var i = Object.defineProperty;
var l = (a, t, e) => t in a ? i(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var r = (a, t, e) => l(a, typeof t != "symbol" ? t + "" : t, e);
import { EditableEntity as s } from "@zdrbm/zdr-native-tools";
class n extends s {
  constructor(e) {
    super(e);
    r(this, "valid");
    this.valid = this.createPropEventBroker("valid", !0);
  }
  setValid(e) {
    this.valid.set(e);
  }
  getEntityName() {
    return "CellData";
  }
}
export {
  n as CellData
};
//# sourceMappingURL=index.es758.js.map
